import { Form, Formik } from "formik";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import users from "../../../apiConfigs/users";
import { ReactComponent as Logo } from "../../../assets/rentisity-logo.svg";
import Input from "../../../designComponents/Input";
import Typography from "../../../designComponents/Typography";
import requestAPI from "../../../utils/requestAPI";
import { ContainerStyled, LoginWrapperStyled } from "../../Login/styles";
import { AcceptButton } from "../../Properties/Details/styles";

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),
});

const SetPasswordForget = () => {
  const params = new URLSearchParams(window.location.search);
  const email = params.get("email") as string;

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const togglePasswordVisible = () => setPasswordVisible(!passwordVisible);
  const toggleConfirmPasswordVisible = () =>
    setConfirmPasswordVisible(!confirmPasswordVisible);

  const initialValues = {
    code: "",
    password: "",
    confirmPassword: "",
    email,
  };

  const handleUpdatePassword = async (values: typeof initialValues) => {
    setIsLoading(true);
    try {
      await requestAPI(
        users.resetPassword({
          email: values.email,
          code: values.code,
          password: values.password,
        })
      );
      toast.success("Password updated successfully!");
      setIsLoading(false);
      navigate("/login");
    } catch (e: any) {
      toast.error(e.message || "failed To reset password");

      setIsLoading(false);
    }
  };

  return (
    <LoginWrapperStyled>
      <ContainerStyled>
        <div className="header">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Logo width={150} style={{ marginBottom: "30px" }} />
            <Typography
              variant="h1"
              fontWeight="bold"
              size="largeTitle"
              color="primary"
              fontFamily="poppins"
            >
              Reset Password
            </Typography>
          </div>
          <Typography
            fontWeight="normal"
            size="subtitle"
            fontFamily="urbanist"
            color="dark.neutral_33"
          >
            Enter code we sent to your email and new password.
          </Typography>
        </div>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleUpdatePassword}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue, handleSubmit, touched, errors }) => (
            <Form onSubmit={handleSubmit}>
              <div
                style={{
                  marginBottom: "15px",
                  gap: "10px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div className="form-container">
                  <Typography
                    style={{
                      color: "#5F5F5F",
                      fontWeight: "600",
                      fontSize: 12,
                    }}
                  >
                    Code*
                  </Typography>
                  <Input
                    placeholder="Enter Code"
                    radius="15px"
                    name="password"
                    type="text"
                    style={{ borderWidth: "1px solid f1effb" }}
                    value={values.code}
                    onChange={(e) => setFieldValue("code", e.target.value)}
                  />
                  {errors.code && touched.code ? (
                    <Typography color="status.red" size="subtitle">
                      {errors.code}
                    </Typography>
                  ) : (
                    ""
                  )}
                </div>
                <div className="form-container">
                  <Typography
                    style={{
                      color: "#5F5F5F",
                      fontWeight: "600",
                      fontSize: 12,
                    }}
                  >
                    Password*
                  </Typography>
                  <Input
                    placeholder="Password"
                    radius="15px"
                    name="password"
                    type={passwordVisible ? "text" : "password"}
                    style={{ borderWidth: "1px solid f1effb" }}
                    value={values.password}
                    onChange={(e) => setFieldValue("password", e.target.value)}
                  />
                  {values?.password?.length > 0 && (
                    <div
                      onClick={togglePasswordVisible}
                      style={{ cursor: "pointer" }}
                    >
                      <Typography
                        style={{
                          textAlign: "right",
                        }}
                      >
                        {!passwordVisible ? "show Password" : "hide Password"}
                      </Typography>
                    </div>
                  )}
                  {errors.password && touched.password ? (
                    <Typography color="status.red" size="subtitle">
                      {errors.password}
                    </Typography>
                  ) : (
                    ""
                  )}
                </div>

                <div className="form-container">
                  <Typography
                    style={{
                      color: "#5F5F5F",
                      fontWeight: "600",
                      fontSize: 12,
                    }}
                  >
                    Confirm Password*
                  </Typography>
                  <Input
                    placeholder="Confirm Password"
                    radius="15px"
                    name="Confirm password"
                    type={confirmPasswordVisible ? "text" : "password"}
                    style={{ borderWidth: "1px solid f1effb" }}
                    value={values.confirmPassword}
                    onChange={(e) =>
                      setFieldValue("confirmPassword", e.target.value)
                    }
                  />
                  {values?.confirmPassword?.length > 0 && (
                    <div
                      onClick={toggleConfirmPasswordVisible}
                      style={{ cursor: "pointer" }}
                    >
                      <Typography
                        style={{
                          textAlign: "right",
                        }}
                      >
                        {!confirmPasswordVisible
                          ? "show Password"
                          : "hide Password"}
                      </Typography>
                    </div>
                  )}
                  {errors.confirmPassword && touched.confirmPassword ? (
                    <Typography color="status.red" size="subtitle">
                      {errors.confirmPassword}0
                    </Typography>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: 10,
                  }}
                >
                  <Link to={"/login"}>
                    <Typography
                      style={{ color: "#003DA8", textDecoration: "underline" }}
                    >
                      Back to Login
                    </Typography>
                  </Link>
                </div>

                <AcceptButton
                  isLoading={isLoading}
                  style={{ marginBottom: "20px", width: "100%" }}
                >
                  Update
                </AcceptButton>
              </div>
            </Form>
          )}
        </Formik>
      </ContainerStyled>
    </LoginWrapperStyled>
  );
};

export default SetPasswordForget;
